import { call, put, takeLatest } from 'redux-saga/effects'
import { dynamicSort } from 'helpers/utils'
import { FETCH_DEVICES } from './constants'
import { apiFetchDevices } from './services'
import { fetchDevices } from './actions'

function* fetchDeviceWorker() {
  const response = yield call(apiFetchDevices)

  if (Array.isArray(response)) {
    const devices = response.sort(dynamicSort('name'))
    yield put(fetchDevices.success(devices))
  }
}

export default function* watcher() {
  yield takeLatest(FETCH_DEVICES.REQUEST, fetchDeviceWorker)
}
